/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PathwaysControllerRemove$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Pathway creation timestamp
 */
  createdAt: string;
}

export function pathwaysControllerRemove(http: HttpClient, rootUrl: string, params: PathwaysControllerRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'message'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, pathwaysControllerRemove.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('createdAt', params.createdAt, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'message'?: string;
      }>;
    })
  );
}

pathwaysControllerRemove.PATH = '/thalea-pathways/pathways/{tenant}/{createdAt}';
